import script from "./TheSkinSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSkinSwiper.vue?vue&type=script&setup=true&lang=js"

import "./TheSkinSwiper.vue?vue&type=style&index=0&id=4b7fe298&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b7fe298"]])

export default __exports__